import { render, staticRenderFns } from "./CarVignettes.vue?vue&type=template&id=1c1d0348&scoped=true&"
import script from "./CarVignettes.vue?vue&type=script&lang=js&"
export * from "./CarVignettes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d0348",
  null
  
)

export default component.exports